export default __webpack_public_path__ + "static/small1-5e33aed50091728b60734b42fe0ea99c.jpg";